import { useAuth } from "@/auth/auth.ts";
import type { components } from "@/client/backend/zz_schema";
import useSWR from "swr";
import useSWRMutation from "swr/mutation";

export type Token = components["schemas"]["Token"];
export type TokenCreate = components["schemas"]["TokenCreate"];

export function useOrganizationTokens(organizationId: string | undefined): {
  tokens: Token[] | "loading";
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  error: any;
} {
  const auth = useAuth();
  const { data, error } = useSWR(
    organizationId ? `/organizations/${organizationId}/tokens` : null,
    () => {
      if (!organizationId) return undefined;
      return auth.client.GET("/organizations/{organizationId}/tokens", {
        params: {
          path: {
            organizationId,
          },
        },
      });
    }
  );

  return {
    tokens: data?.data ?? "loading",
    error,
  };
}

export function useCreateToken(organizationId: string | "loading") {
  const auth = useAuth();

  return useSWRMutation(
    organizationId === "loading" ? null : `/organizations/${organizationId}/tokens`,
    async (_key: string, { arg: tokenCreate }: { arg: TokenCreate }) => {
      if (organizationId === "loading") return undefined;
      return auth.client.POST("/organizations/{organizationId}/tokens", {
        params: {
          path: {
            organizationId,
          },
        },
        body: tokenCreate,
      });
    }
  );
}

export function useRevokeToken(organizationId: string | "loading") {
  const auth = useAuth();

  return useSWRMutation(
    organizationId === "loading" ? null : `/organizations/${organizationId}/tokens`,
    async (_key: string, { arg: tokenId }: { arg: string }) => {
      if (organizationId === "loading") return undefined;
      return auth.client.DELETE("/organizations/{organizationId}/tokens/{tokenId}", {
        params: {
          path: {
            organizationId,
            tokenId,
          },
        },
      });
    }
  );
}